import type { UserHeaderFields } from '@ms/yammer-graphql';

import type { UserCoverImage } from '../../../state/types';

export const processUserCoverImage: (value: UserHeaderFields) => UserCoverImage = ({
  id,
  coverImageUrlTemplate: backgroundUrl,
  defaultCoverImageUrlTemplate: fallbackBackgroundUrl,
  hasDefaultCoverImage,
}) => ({
  id,
  hasDefaultCoverImage,
  backgroundUrl,
  fallbackBackgroundUrl,
});
